import React from "react";
import { IconAlert } from "../../icons/Icon";
import "../../assets/styles/smu-notification-icon.scss";

const SmuNotificationIcon = ({ color, iconColor }) => {
  return (
    <div className="notification-icon" style={{ backgroundColor: color }}>
      <IconAlert color={iconColor || "#fff"} />
    </div>
  );
};

export default SmuNotificationIcon;
